module.exports = __webpack_public_path__ + "static/ff-clan-std-regular-cf7d886be1a10af4a615c87506635b31.woff";